import React, { FunctionComponent, ReactElement } from 'react'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import { SquadPlayerItemProps } from '..'

const FavIcon: FunctionComponent<Pick<SquadPlayerItemProps, 'isFavorite' | 'onFavorite'>> = ({
    isFavorite,
    onFavorite,
}): ReactElement => (
    <Grid noExpand>
        <Touchable expand onPress={onFavorite}>
            <Grid marginX={5} center>
                <FontelloIcon
                    name={isFavorite ? 'favorite-active' : 'favorite'}
                    color={isFavorite ? 'ORANGE' : 'keshi-3'}
                    fontSize={18}
                />
            </Grid>
        </Touchable>
    </Grid>
)

export default FavIcon
